module.exports = "<!-- Created by SGiri 03/12/2018 -->\n\n<div class=\"raul-box\">\n  <div class=\"raul-box-header\">Current Requests</div>\n  <div class=\"raul-box-block p-4\">\n    <div class=\"\">\n      <div style=\"height: 450px;\">\n        <ag-grid-angular class=\"ag-theme-fresh\" [ngStyle]=\"style\" [rowData]=\"rowData\" [columnDefs]=\"columnDefs\" [gridOptions]=\"gridOptions\"\n          (gridReady)=\"onGridReady($event)\">\n        </ag-grid-angular>\n      </div>\n    </div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /azp/_work/1/s/src/app/bi-admin/request/request.component.html
// module id = ../../../../../src/app/bi-admin/request/request.component.html
// module chunks = main